module.exports = __webpack_public_path__ + "files/SPIADI2026 - EXP ADI - Guide Technique (Version 2).5ba51377cbd66d8569beea752c4273fa.pdf";